import { observer } from 'mobx-react';

import Loader, { WHITE, X_SMALL } from '@/common/components/Loader/Loader';
import DriveItemPreview from '@/drive/components/DriveItemPreview/DriveItemPreview';
import { TransientDriveItem } from '@/drive/entities/transientDriveItem';

export interface PinnedItemPreviewProps {
  preview: Nullable<TransientDriveItem>;
  size: number;
  isLoading: boolean;
  className?: string;
}

function PinnedItemPreview(props: PinnedItemPreviewProps) {
  const { preview, size, isLoading, className } = props;

  if (preview) {
    return <DriveItemPreview preview={preview} size={size} />;
  } else {
    return (
      <div className={className} style={{ width: size, height: size }}>
        {isLoading && <Loader appearance={WHITE} size={X_SMALL} />}
      </div>
    );
  }
}

export default observer(PinnedItemPreview);
